import { useSyncExternalStore } from "react";

/**
 * Bascule de mise en page « mobile » (demande utilisateur 2026-09-11 : rendre
 * Sentinelle utilisable sur smartphone). Point de rupture aligné sur celui de
 * **Bulma** (mobile/tablette = 769px, `bulma/css/bulma.min.css` déjà importé) —
 * les écrans qui gardent des classes Bulma (`navbar`, `columns`…) et ceux qui
 * pilotent leur mise en page en JS (grilles CSS inline) restent synchronisés
 * sur le même seuil.
 *
 * `matchMedia` est absent de certains environnements (SSR, jsdom ancien) —
 * repli silencieux sur `false` (mise en page desktop), jamais de levée.
 */
const QUERY = "(max-width: 768px)";

function hasMatchMedia(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}

function subscribe(callback: () => void): () => void {
  if (!hasMatchMedia()) return () => {};
  const mql = window.matchMedia(QUERY);
  try {
    mql.addEventListener("change", callback);
    return () => mql.removeEventListener("change", callback);
  } catch {
    // Safari < 14 : API historique à base d'événements `addListener`.
    mql.addListener(callback);
    return () => mql.removeListener(callback);
  }
}

function getSnapshot(): boolean {
  if (!hasMatchMedia()) return false;
  try {
    return window.matchMedia(QUERY).matches;
  } catch {
    return false;
  }
}

/** `true` sous ~768px de large (téléphone / petite tablette portrait). */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
